/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageTargetTimeSeriesPoint,
  ToolUsageTargetTimeSeriesPoint$inboundSchema,
} from "./toolusagetargettimeseriespoint.js";

/**
 * Time-series MCP and tool usage grouped by target
 */
export type GetToolUsageTargetTimeSeriesResult = {
  /**
   * Time-series usage buckets grouped by target
   */
  targetTimeSeries: Array<ToolUsageTargetTimeSeriesPoint>;
};

/** @internal */
export const GetToolUsageTargetTimeSeriesResult$inboundSchema: z.ZodMiniType<
  GetToolUsageTargetTimeSeriesResult,
  unknown
> = z.pipe(
  z.object({
    target_time_series: z.array(ToolUsageTargetTimeSeriesPoint$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "target_time_series": "targetTimeSeries",
    });
  }),
);

export function getToolUsageTargetTimeSeriesResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageTargetTimeSeriesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetToolUsageTargetTimeSeriesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageTargetTimeSeriesResult' from JSON`,
  );
}
